import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { useHistory, useParams } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { connect } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Article, Prop } from "./animationList";
import ReactLoading from "react-loading";
import { changePassword } from "../../helpers/dbOperations";

  const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [inCaricamento, setinCaricamento] = useState(false);
  const [scad, setScad] = useState()
  const [idDetCliRef, setIdDetCliRef] = useState()
  const { data } = useParams();
  let history = useHistory()
  const handleSubmit = e => {
    var pass = document.getElementById("password")
    var confPass = document.getElementById("confirmPassword")
    if(password.length < 8) {
      alert("Scegliere una password con più di 8 caratteri alfanumerici"); 
      return;
    }
    else if(pass.value != confPass.value) {
      alert("Le due password non coincidono")
      return; 
    } 
    var body = {}
    body["password"] = password
    body["idDetCliRef"] = idDetCliRef
    changePassword(body, addToast, history)
    
  }
  useEffect(() => {
    var params = (atob(data)).split(";");
    setIdDetCliRef(params[0].split("=")[1])
    setScad(params[1].split("=")[1])
  
  },[] )

  const { addToast } = useToasts();
  var strings = require("../../translations/italian.json");
  var informazioni = global.informazioni

  return (
    <Fragment>
      <MetaTags>
        <title>Reset password | {informazioni.titleSite}</title>
          <meta
            name="description"
            content= {"Reset password" + " " + strings.siteContent}
          />
      </MetaTags>

      <LayoutOne headerTop="invisible">
        {/* breadcrumb */}
        <Breadcrumb />
      

        <div className="login-register-area pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-12 ml-auto mr-auto">
                <div className="login-register-wrapper">
                {scad > Date.now() &&
                  <Tab.Container defaultActiveKey="login">
                    <Nav variant="pills" className="login-register-tab-list">
                      <Nav.Item>
                        <Nav.Link eventKey="login">
                          <h4>Reset password</h4>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content>
                      <Tab.Pane eventKey="login">
                        <div className="login-form-container">
                          <div className="login-register-form">
                            <form>
                              <input
                                type="password"
                                name="user-name"
                                placeholder="Password"
                                id="password"
                                minlength="8"
                                onChange={e => setPassword(e.target.value)}
                                required
                              />
                              <input
                                type="password"
                                name="user-name"
                                placeholder="Conferma password"
                                id="confirmPassword"
                                minlength="8"
                                onChange={e => setConfirmPassword(e.target.value)}
                                required
                              />
                              <div className="button-box">
                                <div className="login-toggle-btn">  
                                {!inCaricamento &&                             
                                  <button type="button" onClick={handleSubmit}>
                                    <span>Reset password</span>
                                  </button>
                                }
                                {inCaricamento &&
                                  <Article key={"bars"}>
                                    <ReactLoading type={"bars"} color="black" />
                                    <Prop>{"Bars"}</Prop>
                                  </Article>  
                                }
                                </div>

                              </div>
                            </form>
                          </div>
                        </div>
                      </Tab.Pane>
                      
                    </Tab.Content>
                  </Tab.Container>
                  }
                {scad < Date.now() && 
                <div>
                  <h4>Attenzione!</h4>
                  <p>Il link è scaduto, rifare la procedura di ripristino password!</p>
                </div>
                }
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};


ResetPassword.propTypes = {
};



//export default LoginRegister;
export default connect()(ResetPassword);